import { apiBaseUrl } from './config'

export function cookieValue(name) {
  return document.cookie.split(';').map((item) => item.trim()).find((item) => item.startsWith(`${name}=`))?.split('=').slice(1).join('=') || ''
}

export class ApiError extends Error {
  constructor(message, status, fields = {}) {
    super(message)
    this.status = status
    this.fields = fields
  }
}

export async function apiRequest(path, options = {}) {
  const method = options.method || 'GET'
  const headers = { Accept: 'application/json', ...options.headers }
  if (options.body !== undefined) headers['Content-Type'] = 'application/json'
  if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) headers['X-CSRFToken'] = cookieValue('csrftoken')
  const response = await fetch(`${apiBaseUrl}${path}`, {
    credentials: 'same-origin',
    ...options,
    method,
    headers,
    body: options.body === undefined ? undefined : JSON.stringify(options.body),
  })
  const data = response.status === 204 ? null : await response.json().catch(() => ({}))
  if (!response.ok) {
    const first = Object.values(data || {}).flat()[0]
    throw new ApiError(typeof first === 'string' ? first : 'No fue posible completar la operación.', response.status, data || {})
  }
  return data
}

export async function apiUpload(path, formData, options = {}) {
  const method = options.method || 'POST'
  const response = await fetch(`${apiBaseUrl}${path}`, {
    credentials: 'same-origin',
    ...options,
    method,
    headers: { Accept: 'application/json', 'X-CSRFToken': cookieValue('csrftoken'), ...options.headers },
    body: formData,
  })
  const data = await response.json().catch(() => ({}))
  if (!response.ok) {
    const first = Object.values(data || {}).flat()[0]
    throw new ApiError(typeof first === 'string' ? first : 'No fue posible completar la operación.', response.status, data || {})
  }
  return data
}

export async function prepareCsrf() {
  return apiRequest('/auth/csrf/')
}

export function fieldError(error, name) {
  const value = error?.fields?.[name]
  return Array.isArray(value) ? value[0] : value || ''
}
